/**
 * The announcement state selectors
 */

import {createSelector} from 'reselect';

import makeSelectGlobal from 'domain/selectors';

const makeSelectDomain = () => createSelector(
    makeSelectGlobal(),
    (globalState) => globalState.get('announcement')
);

const makeSelectAnnouncementData = () => createSelector(
    makeSelectDomain(),
    (domainState) => domainState.data
);

export {
    makeSelectAnnouncementData,
};
